<template>
  <a-modal 
    :visible="visible" 
    :title="title" 
    :width="750"
    @cancel="onCancel"
    @ok="onSave"
    cancelText="取消" okText="确认">
    <a-form :form="edit_item">
      <a-row :gutter="10">
        <a-col :span="8">
          <a-form-item label="选配记录名称">
            <a-input v-model="edit_item.name" class="width-100"></a-input>
          </a-form-item>
        </a-col>
      </a-row>
    </a-form>
  </a-modal>
</template>

<script>
export default {
  name: "addOrEditSelectRecord",
  components: {
  },
  data() {
    return {
      action: '',
      edit_item: {},
      edit_item_template: {
        name: '',
        farm_id: '',
      },
      visible: false,
      title: '新增选配记录'
    }
  },
  methods: {
    open(action, farm, item) {
      console.log(action, farm, item);
      
      this.action = action
      this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
      if (action == 'add') {
        this.edit_item.farm_id = farm.id
        this.edit_item.name = new Date().toISOString().slice(0, 10)
      } else {
        this.title = '编辑选配记录'
        this.edit_item = item
      }
      this.visible = true
    },
    onCancel() {
      this.visible = false
    },
    onSave() {
      if (this.action == 'add') {
        this.$api.post_item_select_record(this.edit_item).then(res =>  {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.visible = false
            this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
            this.$emit('finish-edit')
          }
        })
      } else {
        this.$api.put_item_select_record(this.edit_item).then(res =>  {
          if (res.code == 200) {
            this.$message.success("保存成功");
            this.visible = false
            this.edit_item = JSON.parse(JSON.stringify(this.edit_item_template))
            this.$emit('finish-edit')
          }
        })
      }
    },
    on_farm_select(farm_id) {
      this.edit_item.farm_id = farm_id
    },
  },
}
</script>

<style>
</style>